import { seoFor } from "@/lib/i18n/keywordPools";
import { createFileRoute } from "@tanstack/react-router";
import Performance from "@/pages/Performance";
import { MainLayout } from "@/components/layout/MainLayout";

export const Route = createFileRoute("/performance")({
  head: () => ({
    meta: [
      { title: "Prediction Accuracy & Results | Statlign" },
      { name: "keywords", content: seoFor({ topics: ["trackRecord"] }).meta },
      { name: "description", content: "Watch Statlign's live accuracy across markets, leagues and strategies. Numbers, not marketing copy — updated as matches settle." },
      { property: "og:title", content: "Prediction Accuracy & Results | Statlign" },
      { property: "og:type", content: "website" },
      { property: "og:description", content: "Watch Statlign's live accuracy across markets, leagues and strategies. Numbers, not marketing copy — updated as matches settle." },
      { name: "twitter:title", content: "Prediction Accuracy & Results | Statlign" },
      { name: "twitter:description", content: "Watch Statlign's live accuracy across markets, leagues and strategies. Numbers, not marketing copy — updated as matches settle." },
    ],
  }),
  component: () => (
    <MainLayout>
      <Performance />
    </MainLayout>
  ),
});
